import React from 'react';

const StatsCard = ({ icon, value, label, percentage, percentageTextColor, iconBg }) => {
  return (
    <div className="flex items-center bg-white rounded-2xl p-6 shadow-lg space-x-4">
        {/* <FontAwesomeIcon icon={icon} className="text-white text-2xl" /> */}
        <img src={icon} alt='icon' className={`w-20 h-20 ${iconBg} flex items-center justify-center rounded-full`}/>
      <div>
        <h2 className="text-4xl font-bold text-dark">{value}</h2>
        <p className="text-lg text-accent">{label}</p>
        <p className={`text-sm ${percentageTextColor}`}>
          {percentage} (30 days)
        </p>
      </div>
    </div>
  );
};

export default StatsCard;
